import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { REGIONS } from "@/data/site";

// Brand red map pin as an inline SVG divIcon
const pinIcon = L.divIcon({
  className: "asp-pin",
  html: `
    <svg width="30" height="42" viewBox="0 0 30 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 0C6.716 0 0 6.716 0 15c0 10.5 15 27 15 27s15-16.5 15-27C30 6.716 23.284 0 15 0z" fill="#FF3B30"/>
      <circle cx="15" cy="15" r="5.5" fill="#ffffff"/>
    </svg>`,
  iconSize: [30, 42],
  iconAnchor: [15, 42],
  popupAnchor: [0, -38],
});

export default function CityMap() {
  const containerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (mapRef.current || !containerRef.current) return;

    const map = L.map(containerRef.current, {
      scrollWheelZoom: false,
      attributionControl: true,
    });
    mapRef.current = map;

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 18,
      attribution: "© OpenStreetMap",
    }).addTo(map);

    const bounds = [];
    REGIONS.forEach((r) => {
      const marker = L.marker([r.lat, r.lng], { icon: pinIcon }).addTo(map);
      marker.bindPopup(
        `<strong style="font-family:Oswald,sans-serif;text-transform:uppercase;letter-spacing:.03em;">${r.city}</strong><br/><span style="color:#FF3B30;font-weight:600;">${r.uf}</span> · Atendimento 24h`
      );
      bounds.push([r.lat, r.lng]);
    });

    map.fitBounds(bounds, { padding: [40, 40] });

    // Re-measure after layout settles
    const t = setTimeout(() => map.invalidateSize(), 300);

    return () => {
      clearTimeout(t);
      map.remove();
      mapRef.current = null;
    };
  }, []);

  return <div ref={containerRef} className="h-full w-full" data-testid="regions-map" />;
}
